import { render, staticRenderFns } from "./PlanPriceDiscounts.vue?vue&type=template&id=38abef88&scoped=true"
import script from "./PlanPriceDiscounts.vue?vue&type=script&lang=js"
export * from "./PlanPriceDiscounts.vue?vue&type=script&lang=js"
import style0 from "./PlanPriceDiscounts.vue?vue&type=style&index=0&id=38abef88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abef88",
  null
  
)

export default component.exports